/**
 * @deprecated Just write an empty function it is easy ;)
 */
export default function emptyFn() {}
